<template>
  <div class="zk-badge">
    <slot></slot>
    <sup
      v-text="content"
      class="zk-badge__content"
      :class="{ 'is-fixed': $slots.default, 'is-dot': isDot }">
    </sup>
  </div>
</template>

<script>
export default {
  name: 'zk-badge',

  props: {
    value: {},
    max: Number,
    isDot: Boolean
  },

  computed: {
    content() {
      if (this.isDot) return;

      const value = this.value;
      const max = this.max;

      if (typeof value === 'number' && typeof max === 'number') {
        return max < value ? `${max}+` : value;
      }

      return value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// badge.vue?9c8052ec